// Section 17: priority group 'Sick or injured'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function sickOrInjured(_config: Config) {
  return definePriorityGroup({
    id: 'sick-or-injured',
    label: 'Sick or injured',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter((p) => p.status.sick !== null || p.status.injured !== null)
        .map((p) => p.id),
  });
}
